import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';
import { BdList } from '../components/features/basic-design/BdList.js';

/**
 * 一覧を `projects.bd.tsx` ではなく index に置く。`projects.bd.tsx` があると詳細ページがその子に
 * なり、一覧が Outlet を描かない限り `/projects/bd/$bdKey` を開いても一覧が出る。
 *
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 基本設計の入口。成果物のある基本設計を親チケットごとに一覧で出し、基本設計ごとのページへ送る
 * @graph-connects BdList [calls] 基本設計一覧の描画
 */
export const Route = createFileRoute('/projects/bd/')({
  component: BasicDesignListPage,
});

/** @graph-connects BdList [calls] 基本設計一覧の描画 */
function BasicDesignListPage() {
  return (
    <ProtectedRoute pageKey="basicDesign">
      <BdList />
    </ProtectedRoute>
  );
}
